import { Effect } from "./effect.model";
import { EffectStep } from "./effectStep.model";


export class OpacityEffect extends Effect {
  constructor(data: any) {
    super(data);
    this.type = "opacity"
    this.defaultValue = 100
    if (this.steps.length < 1) this.steps = [new EffectStep({ time: 0, value: this.defaultValue })]
  }
}

export class PositionEffect extends Effect {
  anchor?: string;
  params: { anchor: string } = { anchor: "tl" };

  constructor(data: any) {
    super(data);
    this.params = { anchor: "tl" };
    this.type = "position"
    this.defaultValue = [0, 0]
    if (this.steps.length < 1) this.steps = [new EffectStep({ time: 0, value: this.defaultValue })]
  }
}

export class ScaleEffect extends Effect {
  constructor(data: any) {
    super(data);
    this.type = "scale"
    this.defaultValue = [100, 100]
    if (this.steps.length < 1) this.steps = [new EffectStep({ time: 0, value: this.defaultValue })]
  }
}

export class KeylightEffect extends Effect {
  params: {
    from_color: string | [number, number, number];
    to_color: string | [number, number, number];
    tolerance: number;
  } = { from_color: "#000000", to_color: "#000000", tolerance: 0 };

  constructor(data: any) {
    super(data);
    this.type = "keylight"
    this.params = data?.params || {
      from_color: "#000000",
      to_color: "#000000",
      tolerance: 0,
    };
  }
}

export class DropShadowEffect extends Effect {
  params: {
    radius: number,
    offset: number[],
    opacity: number,
  } = { radius: 5, offset: [2, 2], opacity: 1 }

  constructor(data: any) {
    super(data);
    this.type = "dropshadow"
    this.params = data?.params ? data.params : this.params
  }
}